/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HealthCard
 */
export interface HealthCard {
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    province: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof HealthCard
     */
    date?: number;
    /**
     * 
     * @type {number}
     * @memberof HealthCard
     */
    date_of_birth?: number;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    second_name?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    gender?: HealthCardGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    health_number: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    version_code?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HealthCard
     */
    valid_card?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    response_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    response_code?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    response_description?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    response_action?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    status_code?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCard
     */
    message?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof HealthCard
     */
    expiry_date?: Array<number>;
}


/**
 * @export
 */
export const HealthCardGenderEnum = {
    Male: 'Male',
    Female: 'Female'
} as const;
export type HealthCardGenderEnum = typeof HealthCardGenderEnum[keyof typeof HealthCardGenderEnum];


/**
 * Check if a given object implements the HealthCard interface.
 */
export function instanceOfHealthCard(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "province" in value;
    isInstance = isInstance && "health_number" in value;

    return isInstance;
}

export function HealthCardFromJSON(json: any): HealthCard {
    return HealthCardFromJSONTyped(json, false);
}

export function HealthCardFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthCard {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'province': json['province'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'date_of_birth': !exists(json, 'date_of_birth') ? undefined : json['date_of_birth'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'second_name': !exists(json, 'second_name') ? undefined : json['second_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'health_number': json['health_number'],
        'version_code': !exists(json, 'version_code') ? undefined : json['version_code'],
        'valid_card': !exists(json, 'valid_card') ? undefined : json['valid_card'],
        'response_id': !exists(json, 'response_id') ? undefined : json['response_id'],
        'response_code': !exists(json, 'response_code') ? undefined : json['response_code'],
        'response_description': !exists(json, 'response_description') ? undefined : json['response_description'],
        'response_action': !exists(json, 'response_action') ? undefined : json['response_action'],
        'status_code': !exists(json, 'status_code') ? undefined : json['status_code'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'expiry_date': !exists(json, 'expiry_date') ? undefined : json['expiry_date'],
    };
}

export function HealthCardToJSON(value?: HealthCard | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'province': value.province,
        'status': value.status,
        'date': value.date,
        'date_of_birth': value.date_of_birth,
        'first_name': value.first_name,
        'second_name': value.second_name,
        'last_name': value.last_name,
        'gender': value.gender,
        'health_number': value.health_number,
        'version_code': value.version_code,
        'valid_card': value.valid_card,
        'response_id': value.response_id,
        'response_code': value.response_code,
        'response_description': value.response_description,
        'response_action': value.response_action,
        'status_code': value.status_code,
        'message': value.message,
        'expiry_date': value.expiry_date,
    };
}

